import { listThemes } from './themeDB.js';
import { externalThemeKey, registerExternalTheme } from '../Hasp/properties/ConfigManager.js';

/** Load and register all locally available JSONL themes for synchronous use. */
export async function loadExternalThemes() {
    let themes;
    try {
        themes = await listThemes();
    } catch (error) {
        console.warn('Theme library is unavailable; continuing with built-in themes:', error);
        return [];
    }
    const usableThemes = [];
    for (const theme of themes) {
        if (!theme?.id || !theme?.text) continue;
        try {
            registerExternalTheme(externalThemeKey(theme.id), theme.text);
            usableThemes.push(theme);
        } catch (error) {
            // A malformed library row should not prevent built-in themes from
            // loading, nor prevent the rest of the designer from starting.
            console.warn(`Theme "${theme.name ?? theme.id}" cannot be used in the canvas preview:`, error);
        }
    }
    return usableThemes;
}

export { externalThemeKey };
